/*****
 * VIEWPORT上書き
 */
export default () => {
  const [d,h,m,p] = [document, 'head', 'meta', ['viewport', window.siteinfo.viewport]]
  const f = d.getElementsByTagName(h)[0],j = d.querySelector(`${m}[name=${p[0]}]`);
  j.content = p[1];f.insertBefore(j, null);
}